import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCompanyInfoResponse } from '@/api/my-business/agency-chains/get-company-info'

export const mockGetCompanyInfos = http.get<{ id: string }>(
  '/my-business/api/agency/v1/company-infos/:id',
  () => {
    const data: GetCompanyInfoResponse = {
      active: true,
      alphaId: faker.string.uuid(),
      followingPolicy: faker.datatype.boolean(),
      followingPolicyCompanyType: faker.helpers.arrayElement([
        'AGENCY_CHAIN',
        'TRAVEL_AGENCY',
      ]),
      companyId: faker.number.int(6),
      legalData: {
        companyTypeCode: faker.helpers.arrayElement([
          'TRAVEL_AGENCY',
          'AGENCY_CHAIN',
          'POS',
          'CUSTOMER',
        ]),
        corporateName: faker.company.name(),
        municipalRegistration: '',
        name: faker.company.name(),
        stateRegistration: '',
        taxpayerId: faker.string.numeric(14),
        observation: faker.lorem.sentence(),
      },
      responsibleData: {
        name: faker.person.fullName(),
        companyPosition: faker.person.jobTitle(),
        responsibleTaxpayerId: faker.string.numeric(11),
      },
      companyChainProfileData: {
        companyChainClassification: faker.helpers.arrayElement([
          'BASIC',
          'SMART',
        ]),
        companyChainProfileStatusEnum: 'RELEASED',
        companyChainType: faker.helpers.arrayElement(['AGENCY', 'OPERATOR']),
        observation: faker.lorem.sentence(),
      },
      contracts: {
        b2bContract: faker.internet.url(),
        inheritedFrom: faker.helpers.arrayElement([
          'AGENCY_CHAIN',
          'TRAVEL_AGENCY',
        ]),
        socialContract: faker.internet.url(),
      },
    }

    return HttpResponse.json({ data: [data] }, { status: 200 })
  },
)
